import { MutationTree } from 'vuex';
import { BulkDistrItem, DistrModerationState } from './types';

export const mutations: MutationTree<DistrModerationState> = {
  setBulkDistrList: (state, data: BulkDistrItem[]) => {
    state.bulkDistrList = data;
  },
  setBulkDistrItem: (state, data: BulkDistrItem) => {
    state.bulkDistrItem = data;
  },
}